import React from 'react'
import Collapsible from 'react-collapsible'
import { Text } from '@sendoutcards/quantum-design-ui'

import { Category } from 'src/graphql'
import { Feature as FeatureType, PlanFeature } from 'src/marketing/plans/types'
import { Feature, PricingCell } from 'src/marketing/plans/components'

import { boxShadow, style } from './pricingTableStyles'
import { useSubscriptions } from 'src/hooks'

const cellStyle: React.CSSProperties = { minWidth: 0 }

const lastCategory = (index: number, categories: Category[]): boolean => {
  if (categories) {
    return index === categories.length - 1
  }
  return false
}

const isLastRow = (index: number, category: Category): boolean =>
  index === category.features.length - 1

type PricingTableProps = {
  categories: Category[]
  isOpen: boolean
}

const FeatureCell: React.FC<PricingTableProps> = props => {
  const { categories, isOpen } = props

  const { currentPlan } = useSubscriptions()

  // TODO: remove hardcoded disable when features are updated
  const isDisabled = true

  if (isDisabled) {
    return <></>
  }

  return (
    <Collapsible trigger="" open={isOpen}>
      <div>
        {categories.map((category: Category, categoryIndex: number) => (
          <React.Fragment key={category.title}>
            <div style={style.categoryHeader}>
              <Text type="caption" weight="semiBold">
                {category.title}
              </Text>
            </div>
            {category.features.map((feature: FeatureType, index: number) => (
              <div
                key={feature.title}
                style={{
                  display: 'flex',
                  marginBottom:
                    !lastCategory(categoryIndex, categories) &&
                    isLastRow(index, category)
                      ? 0
                      : 15,
                  boxShadow:
                    !lastCategory(categoryIndex, categories) &&
                    isLastRow(index, category)
                      ? 'unset'
                      : boxShadow,
                }}
              >
                <Feature
                  id={index}
                  title={feature.title}
                  description={feature.description}
                />
                {feature.plans &&
                  feature.plans.map(
                    (planFeature: PlanFeature, index: number) => (
                      <PricingCell
                        key={index}
                        plan={planFeature}
                        planColor={planFeature.color ?? ''}
                        containerStyle={cellStyle}
                        isCurrentPlan={
                          planFeature.plan
                            ? currentPlan.id === planFeature.plan
                            : false
                        }
                      />
                    ),
                  )}
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </Collapsible>
  )
}

export default FeatureCell
